import { useState } from 'react';
import { LuMail, LuLoaderCircle } from 'react-icons/lu';
import { apiFetch } from '../services/api';

interface AvisoConfirmarEmailProps {
  /** O e-mail para onde o link foi. Vem do `user` do localStorage. */
  email?: string;
}

/**
 * A cobrança da confirmação de e-mail, decidida por ele em 2026-09-13:
 * mora na Home, e fica lá enquanto a pessoa não confirmar.
 *
 * Entra DENTRO da coluna, acima da saudação — não presa no topo da tela. A Home
 * é `as-centro`, uma coluna centrada na vertical, e é por isso que ela não usa
 * PageHeader (o comentário no topo do HomePage.tsx registra: com ele, "a coluna
 * ficava presa no topo com meia tela vazia embaixo"). Uma faixa fixada no alto
 * reintroduziria exatamente esse vão; dentro da coluna ela sobe junto com o resto.
 *
 * Filete sobre a superfície, sem fundo de cor: não é aviso de erro, é uma
 * pendência — e pintar a faixa quebraria a regra de não preencher para dar
 * contraste.
 */
const AvisoConfirmarEmail = ({ email }: AvisoConfirmarEmailProps) => {
  const apiUrl = import.meta.env.VITE_API_URL;
  const [estado, setEstado] = useState<'ocioso' | 'enviando' | 'enviado'>('ocioso');

  const reenviar = async () => {
    if (estado !== 'ocioso') return;
    setEstado('enviando');
    try {
      await apiFetch(`${apiUrl}/api/Auth/ReenviarConfirmacao`, { method: 'POST' });
      setEstado('enviado');
      /* Trava por 60s, como o botão de código já fazia. Sem contagem visível:
         aqui não há pressa, o link vale 7 dias. */
      setTimeout(() => setEstado('ocioso'), 60000);
    } catch {
      setEstado('ocioso');
    }
  };

  return (
    <div className="as-confirma" role="status">
      <LuMail size={16} />
      <span className="as-confirma-txt">
        Confirme o seu e-mail.
        {email && <> Enviamos um link para <strong>{email}</strong>.</>}
      </span>
      {estado === 'enviado' ? (
        <span className="as-confirma-ok">Enviado</span>
      ) : (
        <button type="button" className="as-confirma-btn" onClick={reenviar} disabled={estado === 'enviando'}>
          {estado === 'enviando' ? <LuLoaderCircle size={13} className="au-spin" /> : 'Reenviar'}
        </button>
      )}
    </div>
  );
};

export default AvisoConfirmarEmail;
